import {ConfigurationApplication} from '@application/Config';
import {getAuth} from '@infra/api/authManager/authManager';
import {proxy} from '@infra/api/fetch/proxy';
import {Environment} from '@domain/model/Config/Configuration';
import {bootstrap, SentryEnvironment} from '@lookiero/look-and-like';
import {version} from '@lookiero/look-and-like/package.json';
import {PROJECT_ID} from './sentryConfig';

const configuration = ConfigurationApplication.retrieve();

const sentry = (): SentryEnvironment => ({
  publicKey: 'a6beababbfccbf57ffdd7408aa9a2b2a',
  release: `look-and-like@${version}`,
  project: PROJECT_ID,
  environment: configuration.environment === Environment.DEVELOPMENT ? 'development' : 'production',
});

const {root} = bootstrap({
  apiUrl: () => proxy('/lookandlike'),
  getAuthToken: getAuth as unknown as () => Promise<string>,
  sentry,
});

export {root};
